export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filters are loading"])}
      },
      "de": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter werden geladen"])}
      }
    }
  })
}
